/* TT123 – productfoto's automatisch inzoomen tot de rand van het kader (witruimte in de foto wegsnijden, nooit buiten het kader) */
(function () {
  var SEL = '.card__media img,.pdp__main img,.thumbs img,.cartrow__img img';
  var MAX = 2.4, FILL = 0.94, N = 96, T = 236;
  function bbox(img) {
    var c = document.createElement('canvas'); c.width = N; c.height = N;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, N, N);
    var d; try { d = x.getImageData(0, 0, N, N).data; } catch (e) { return null; }
    var m = new Uint8Array(N * N);
    for (var p = 0; p < N * N; p++) { var i = p * 4; m[p] = (d[i + 3] > 16 && (d[i] < T || d[i + 1] < T || d[i + 2] < T)) ? 1 : 0; }
    var x0 = N, y0 = N, x1 = -1, y1 = -1;
    for (var y = 0; y < N - 1; y++) {
      for (var xx = 0; xx < N - 1; xx++) {
        var q = y * N + xx;
        if (m[q] && m[q + 1] && m[q + N] && m[q + N + 1]) { if (xx < x0) x0 = xx; if (xx + 1 > x1) x1 = xx + 1; if (y < y0) y0 = y; if (y + 1 > y1) y1 = y + 1; }
      }
    }
    if (x1 < 0) return null;
    return { x0: x0 / N, y0: y0 / N, x1: (x1 + 1) / N, y1: (y1 + 1) / N };
  }
  function fit(img) {
    if (!img.complete || !img.naturalWidth) return;
    var W = img.clientWidth, H = img.clientHeight; if (!W || !H) return;
    var b = bbox(img);
    if (!b) { img.style.transform = ''; return; }
    var nw = img.naturalWidth, nh = img.naturalHeight, s = Math.min(W / nw, H / nh);
    var dw = nw * s, dh = nh * s, ox = (W - dw) / 2, oy = (H - dh) / 2;
    var bx = ox + b.x0 * dw, by = oy + b.y0 * dh, bw = (b.x1 - b.x0) * dw, bh = (b.y1 - b.y0) * dh;
    var k = Math.min(W * FILL / bw, H * FILL / bh, MAX);
    if (!(k > 1.02)) { img.style.transform = ''; return; }
    var tx = -k * (bx + bw / 2 - W / 2), ty = -k * (by + bh / 2 - H / 2);
    img.style.transformOrigin = '50% 50%';
    img.style.transform = 'translate(' + (tx / W * 100).toFixed(2) + '%,' + (ty / H * 100).toFixed(2) + '%) scale(' + k.toFixed(3) + ')';
  }
  function run(root) { (root || document).querySelectorAll(SEL).forEach(function (img) { if (img.complete) fit(img); }); }
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.matches(SEL)) fit(t); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  window.addEventListener('load', function () { run(); });
  var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(run, 200); });
  if ('MutationObserver' in window) new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches(SEL)) { if (n.complete) fit(n); } else run(n); } }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* TT123 – snelheid/spin/controle-balken: waarden op schaal 0–10 of 0–140 netjes binnen de balk */
(function () {
  function bars() {
    document.querySelectorAll('.bar').forEach(function (bar) {
      var b = bar.querySelector('b'), s = bar.querySelector('.bar__t span'); if (!b || !s) return;
      var n = parseFloat(String(b.textContent).replace(',', '.')); if (isNaN(n)) return;
      var pct = n <= 10 ? n * 10 : n / 1.4; s.style.width = Math.max(0, Math.min(100, pct)).toFixed(1) + '%';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bars); else bars();
})();
